import React from 'react';
import { connect } from 'react-redux';
import { isEqual } from 'lodash';

import CSV from '../../../helpers/CSVExport';


import Box from '../Box';
import { statsActions } from '../../../data/actions/stats';
import StackedBarChart from '../../widgets/charts/types/StackedBarChart';
import LineChart from '../../widgets/charts/types/LineChart';

var downloadSvg = require('!svg-inline-loader!../../../../public/img/download.svg');
var barSvg = require('!svg-inline-loader!../../../../public/img/chart-bar.svg');
var lineSvg = require('!svg-inline-loader!../../../../public/img/line.svg');

import VendorLogo from "../VendorLogo";
import { dspLogos } from "../../common/Stats/utils";
import ModeSelect from '../ModeSelect';


class PreAdd extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
		  mode: props.defaultMode || 'line',
		  defaultSorted: [{ id: "curr_units", desc: false }],
		  logoDataFiltered: [],
		};
		this.setChartMode = this.setChartMode.bind(this);
		this.exportToCsv = this.exportToCsv.bind(this);
	}

	setChartMode(mode){
		this.setState({mode});
		const { modeChange } = this.props;
		
		if(typeof modeChange == 'function')
			modeChange(mode);
	}

	exportToCsv(){
		const filename = CSV.CSVHeader('details_devices', 'curr_units', this.props.filter.global, this.props.parentEntityTitle); 
		return CSV.CSVExport(this.props.stats.devices.table, {filename});
	}
	
	componentDidMount() {
		const { chartType } = this.props;
		const { mode } = this.state;
		this.props.dispatch(statsActions.getPreAdd(this.props.filtered));
	}
	
	
	componentWillReceiveProps(nextProps){
		const globalFilter = nextProps.filter.global;
		const { chartType } = this.props;
		if(nextProps.filter && globalFilter){
			if(this.props.filter.global!==undefined && !isEqual(globalFilter, this.props.filter.global)) {
				this.props.dispatch(statsActions.getPreAdd(this.props.filtered));
				
				this.setState((prevState) => {
				  return {
					...prevState,
					mode: 'table',
					logoDataFiltered: chartType
					  ? dspLogos[chartType].data.filter((l) =>
						  globalFilter.vendors.includes(l)
						)
					  : [],
				  };
				});
			}                
		}
	}
	
	renderToolbar(modes){
		let toolbar = [];

		let options = [
			{icon: lineSvg, value: 'line', label: "Line Chart"},
			{icon: barSvg, value: 'bar', label: "Bar Chart"}
		];

		toolbar.push(<div key="wrapper" className="ibox-action-wrapper">
			<div className="ibox-icon-holder mode-select">
			<ModeSelect options={options} selected={this.state.mode} onChange={this.setChartMode} isSearchable={ false } />
		</div>
		</div>)
		return toolbar;
	}  

	renderExportToCsv() {
		return (
			<a key="download" title="Export CSV" onClick={this.exportToCsv} className="download-link" dangerouslySetInnerHTML={{__html: downloadSvg}} />
		)
	}
	
	renderVendorLogos() {
		const { chartType } = this.props;
		const logoData = chartType ? this.state.logoDataFiltered : [];

		return <div className="title-vendors-list">
			{chartType && logoData && logoData.map((l) => (
				<VendorLogo key={l} name={l} />
			))}
		</div>
	}
	
	
	
	render (){
		const stats = this.props.stats;
		let { shadowChartProps } = this.props;
		if(shadowChartProps){
			shadowChartProps.shadowChart = true;
		}
		console.log(stats.preAdd)

		return <Box title="Pre-Add" toolbar={this.renderToolbar()} vendorLogoList={this.renderVendorLogos()} spinnerEnabled={stats.preAddLoading} exportToCsv={this.renderExportToCsv()}>
				{this.state.mode=='line' && <div className="chart-block">
					<LineChart data={stats.preAdd} {...shadowChartProps}  />                          
				</div>}
				{this.state.mode=='bar' && <div className="chart-block">
					<StackedBarChart data={stats.preAdd} {...shadowChartProps}  />                          
				</div>}
		</Box>
	}
}

function mapStateToProps(state) {
	return {
		stats: state.stats,
		filter: state.filter
	} 
}

export default connect(mapStateToProps)(PreAdd);